// Import Libraries
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// Import JSX Modules
import PreviewableProducts from './previewable-products';
import GenericProducts from './generic-products';
import productType from './types/product-type';
import deliveryOptionType from './types/delivery-option-type';

class Products extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
      modalContent: {},
    };
  }

  handleModalClose = () => this.setState({ modalOpen: false });

  handleProductOnClick = e => {
    const { previewInModal } = this.props;

    if (previewInModal) {
      e.preventDefault();
      this.setState({ modalOpen: true });
    }
  };

  handleModalContent = modalContent => {
    this.setState({ modalContent });
  };

  render() {
    const {
      deliveryOptions,
      favourites,
      isMobileFilterOpen,
      preSelections,
      previewInModal,
      products,
      roundOption,
      showThumbnailImages,
      selectedDeliveryOptions
    } = this.props;

    const { modalOpen, modalContent } = this.state;
    const productsWithMultipleVariants = products.filter(product => product.variants && product.variants.length > 1).length > 0
    return (
      <section
        className={classNames('products', {
          'd-none': isMobileFilterOpen,
        })}
        aria-label="products">
        {previewInModal ? (
          <PreviewableProducts
            products={products}
            preSelections={preSelections}
            favourites={favourites}
            roundOption={roundOption}
            modalOpen={modalOpen}
            modalContent={modalContent}
            handleProductOnClick={this.handleProductOnClick}
            handleModalContent={this.handleModalContent}
            handleModalClose={this.handleModalClose}
            deliveryOptions={deliveryOptions}
            showThumbnailImages={showThumbnailImages}
            productsWithMultipleVariants={productsWithMultipleVariants}
            selectedDeliveryOptions={selectedDeliveryOptions}
          />
        ) : (
          <GenericProducts
            products={products}
            preSelections={preSelections}
            favourites={favourites}
            roundOption={roundOption}
            showThumbnailImages={showThumbnailImages}
            productsWithMultipleVariants={productsWithMultipleVariants}
            selectedDeliveryOptions={selectedDeliveryOptions}
          />
        )}
      </section>
    );
  }
}

Products.propTypes = {
  favourites: PropTypes.arrayOf(PropTypes.string),
  isMobileFilterOpen: PropTypes.bool,
  preSelections: PropTypes.shape({
    page: PropTypes.number,
    search: PropTypes.string,
    showMobileFiltersFullScreen: PropTypes.bool,
    sort: PropTypes.string,
  }).isRequired,
  products: PropTypes.arrayOf(productType).isRequired,
  roundOption: PropTypes.bool.isRequired,
  previewInModal: PropTypes.bool,
  deliveryOptions: PropTypes.arrayOf(deliveryOptionType),
  selectedDeliveryOptions: PropTypes.string
};

Products.defaultProps = {
  favourites: null,
  isMobileFilterOpen: null,
  previewInModal: false,
  deliveryOptions: null
};

export default Products;
